import { useGameStore } from '../store/gameSlice';
import { useNetSessionStore } from '../store/netSessionSlice';

/**
 * Whether the Pixi world (sim + animations) should freeze on local pause.
 *
 * Solo: yes — opening an interface stops the ticker. Co-op: no — the shared
 * world is host-authoritative and live for everyone, so a local menu must not
 * freeze it (the host opening a menu would otherwise stop the whole party's
 * simulation). The menu-user's own input is gated by the input-context stack,
 * not by pause, so the world keeps running while they can't act.
 */
export function useWorldFrozen(): boolean {
  const isPaused = useGameStore((s) => s.isPaused);
  const role = useNetSessionStore((s) => s.role);
  return isPaused && role === 'offline';
}
